<template>
	<div class="FieldRadioImage">
		<label class="FieldRadioImageItem" v-for="option of field.options">
			<span class="FieldRadioImageItem-image" v-if="option.image">
				<img :src="option.image.thumbnail">
			</span>
			<input type="radio" :value="option.value" v-model="field.value">
			<span class="FieldRadioImageItem-title">{{option.label}}</span>
		</label>
	</div>
</template>

<script>
	export default {
		props: {
			field: Object
		}
	}
</script>

<style lang="scss" scoped>
	.FieldRadioImage {
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));;
		grid-gap: 1em;
		@media (max-width: 680px) {
			grid-template-columns: 1fr;
		}
	}

	.FieldRadioImageItem {
		background: var(--colorBrand);
		color: #fff;
		position: relative;
		border: 2px solid var(--colorBrand);
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		text-align: center;
		padding: 2em;
		min-height: 20em;
		cursor: pointer;

		&-image {
			img {
				position: absolute;
				left: 0;
				top: 0;
				width: 100%;
				height: 100%;
				object-fit: cover;
				opacity: .3;
			}
		}

		input {
			position: relative;
		}

		&-title {
			position: relative;
			font-size: var(--textLg);
			font-weight: 700;
		}

		input[type=radio] {
			-moz-appearance: none;
			-webkit-appearance: none;
			appearance: none;
			color: #fff;
			border: 2px solid currentColor;
			width: 1.4em;
			height: 1.4em;
			border-radius: 50%;
			background: transparent;
			transition: all .25s ease-in-out;
			outline: none;
			display: inline-flex;
			margin-bottom: .5em;

			&:before {
				content: ' ';
				display: block;
				width: 59%;
				height: 59%;
				border-radius: 50%;
				background: currentColor;
				opacity: 0;
				margin: auto;
			}

			&:checked {
				background: var(--colorBrand);

				&:before {
					opacity: 1;
				}
			}
		}
	}
</style>